const jQuery = require('jquery');

/**
 * External Links  plugin for jQuery
 * Plugin to open external links in new window/tab.
 *
 * @version: 1.0.0
 * @author: Karel Müller (FG Forrest, a.s.)
 */

(function($) {
	"use strict";

	// Plugin definition.
	$.externalLinks = function( options ) {
		// Extend our default options with those provided.
		const settings = $.extend({
			labels:      {
				"cs": "Odkaz se otevře v novém okně",
				"sk": "Odkaz sa otvorí v novom okne",
				"en": "Link opens in a new window",
				"en-GB": "Link opens in a new window",
				"en-US": "Link opens in a new window",
				"de": "Link im neuen Fenster öffen",

				"bg": "Отваря се връзката в нов прозорец",
				"es": "El enlace se abre en una nueva ventana",
				"da": "Link åbner i et nyt vindue",
				"et": "Link avaneb uues aknas",
				"el": "Ο σύνδεσμος ανοίγει σε νέο παράθυρο",
				"fr": "Lien ouvre dans une nouvelle fenêtre",
				"ga": "Osclaíonn an nasc i bhfuinneog nua",
				"hr": "Link se otvara u novom prozoru",
				"it": "Link si apre in una nuova finestra",
				"lv": "Saite atveras jaunā logā",
				"lt": "Nuoroda atsidaro naujame lange",
				"hu": "Hivatkozás megnyit egy új ablakban",
				"mt": "Link jiftaħ tieqa ġdida",
				"nl": "Link opent in een nieuw venster",
				"pl": "Otwiera link w nowym oknie",
				"pt": "O link se abre em uma nova janela",
				"ro": "Link deschide într-o fereastră nouă",
				"sl": "Povezava se odpre v novem oknu",
				"fi": "Linkki avautuu uuteen ikkunaan",
				"sv": "Länken öppnas i ett nytt fönster",
				"ru": "Ссылка откроется в новом окне"
			},
			separator:   `|`,
			iconArea:    ``, // parent selector
			iconType:    `class`, // 'class' | 'element'
			iconClass:   `external`,
			iconElement: `<svg class="svg-icon-external"><use xlink:href="/img/svg/svg-sprite.svg#icon-external"></use></svg>`,
			addIcon:     true, // true | false
			removeIcon:  ``, // parent selector
		}, options);

		const getPageLang = function() {
			return $('html').attr('lang') || 'en';
		};

		const getTitleCorrespondingToLang = function() {
			return settings['labels'][getPageLang()];
		};

		const addIcon = function($obj) {
			if (settings['iconType'] === 'class') {
				$obj.addClass(settings['iconClass']);
			} else if (settings['iconType'] === 'element') {
				$obj.append(settings['iconElement']);
			}
		};

		// Our plugin implementation code goes here.
		return $('a').each(function() {
			const $obj = $(this);

			if((this.hostname !== location.hostname) && ((this.protocol === 'https:') || (this.protocol === 'http:'))) {
				let $title = $obj.prop('title');

				if (typeof $title === 'undefined') {
					$title = ``;
				}

				if ($title !== '') {
					$title += ` ${settings['separator']} ${getTitleCorrespondingToLang()}`;
				} else {
					$title += getTitleCorrespondingToLang();
				}
				$obj.prop('target', '_blank').prop('title', $title);
			}

			if ($obj.attr('target') === '_blank') {
				if (settings['addIcon'] === true) {
					if ((settings['iconArea'] === '' || $obj.parents(settings['iconArea']).length) && ($obj.parents(settings['removeIcon']).length === 0)) {
						addIcon($obj);
					}
				}
			}
		});
	};
})(jQuery);



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/jquery.externalLinks.js